import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllEquipments(page: number, size: number, search: string, kindId?: number, isActive?: boolean, movementType?: number, movementPersonId?: number, projectId?: number) {
    let query = `page=${page}&size=${size}&search=${encodeURIComponent(search || '')}`;
    if (kindId !== undefined && kindId !== null) {
      query += `&kindId=${kindId}`;
    }
    if (isActive !== undefined && isActive !== null) {
      query += `&isActive=${isActive}`;
    }
    if (movementType !== undefined && movementType !== null) {
      query += `&MovementType=${movementType}`
    }

    if (movementPersonId !== undefined && movementPersonId !== null) {
      query += `&movementPersonId=${movementPersonId}`
    }
    if(projectId !== undefined && projectId !== null){
      query += `&projectId=${projectId}`
    }

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Equipment,
      queryString: query
    });

    return await firstValueFrom(observable);
  }


  async getByIdEquipment(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Equipment,
    }, id);
    return await firstValueFrom(observable);
  }

  async createEquipment(data: any) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Equipment
    }, data);
    return await firstValueFrom(observable);
  }

  async createEquipments(data: any) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Equipment,
      action: "createEquipments"
    }, data);
    return await firstValueFrom(observable);
  }

  async updateEquipment(data: any) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Equipment
    }, data);
    return await firstValueFrom(observable);
  }

  async deleteEquipment(id: number) {
    const observable: Observable<any> = this.httpClientService.delete({
      controller: ControllerType.Equipment,
      action: `${id}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdEquipmentHistoryMovement(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Equipment,
      action: "GetByIdEquipmentHistoryMovement"
    }, id);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
